(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ContratDetailController', ContratDetailController);

    ContratDetailController.$inject = ['$scope', '$rootScope', '$state', '$stateParams', 'entity', 'Contrat','Principal','Agence', 'AlertService', 'AssistantPanelService', '$translate'];

    function ContratDetailController($scope, $rootScope, $state, $stateParams, entity, Contrat ,Principal,Agence, AlertService, AssistantPanelService, $translate ) {
        var vm = this;
        vm.idContrat = $stateParams.id;
        vm.contrat = entity;
		vm.$state = $state;
		vm.canEditContract = false;
        vm.canUseAssistant = false;
        vm.downloadContractJson = downloadContractJson;
        vm.openAssistantChat = openAssistantChat;
		  
        vm.load = function (id) {
            Contrat.get({id: id}, function(result) {
                vm.contrat = result;
                AssistantPanelService.updateContextEntity(result);
            });
        };
        var unsubscribe = $rootScope.$on('wamasysApp:contratUpdate', function(event, result) {
            vm.contrat = result;
            AssistantPanelService.updateContextEntity(result);
        });
        $scope.$on('$destroy', unsubscribe);

		    Principal.identity().then(function(account) {
		    	if(account){
		            vm.canEditContract = account.authorities.indexOf('ROLE_DATA_OPERATOR') !== -1
					 ||  account.authorities.indexOf('ROLE_AREA_MANAGEMENT') !== -1
					 ||  account.authorities.indexOf('ROLE_ADMIN') !== -1;
                    vm.canUseAssistant = (account.modules || []).indexOf('AI_ASSISTANT') !== -1
                        && (account.authorities.indexOf('ROLE_ADMIN') !== -1
                        || account.authorities.indexOf('ROLE_SUPER_ADMIN') !== -1);
					
					    
		    		vm.onlinePaymentConf =  Agence.getOnlinePaymentConf({idArea:account.agence.id});
		        
		    	}
		    });
        function downloadContractJson() {
            Contrat.downloadContractJson({id: vm.idContrat}, function(content) {
                var url = URL.createObjectURL(content.response);
                var a = document.createElement('a');
                a.href = url;
                a.download = content.fileName || ('export-contract-' + vm.idContrat + '.json');
                a.click();
                URL.revokeObjectURL(url);
            }, function(error) {
                AlertService.error(error.data && error.data.message ? error.data.message : 'Unable to download contract JSON export');
            });
        }

        function openAssistantChat() {
            AssistantPanelService.open({
                contextType: 'CONTRACT',
                entityId: vm.idContrat,
                title: $translate.instant('global.assistant.contractTitle'),
                subtitle: vm.contrat && vm.contrat.referenceContrat ? ('#' + vm.contrat.referenceContrat) : null,
                promptPlaceholder: $translate.instant('global.assistant.contractPromptPlaceholder'),
                supportsActionProposal: true,
                supportsDataScopes: true,
                supportsAssistantFlowModes: true,
                defaultAllowAssistantToChooseData: false,
                defaultSelectedDataScopes: [],
                defaultResponseDetailLevel: 'SHORT',
                defaultSelectedModel: 'gpt-4.1-mini',
                defaultCreativityLevel: 'PRECISE',
                defaultAssistantFlowMode: 'OPTIMIZED',
                entity: vm.contrat,
                adapter: {
                    chat: function(payload, success, error) {
                        Contrat.chatAssistant({id: vm.idContrat}, payload, success, error);
                    },
                    getUsage: function(success, error) {
                        Contrat.getAssistantUsage({id: vm.idContrat}, success, error);
                    },
                    recoverLatestResponse: function(payload, success, error) {
                        Contrat.recoverAssistantResponse({id: vm.idContrat, conversationId: payload.conversationId}, success, error);
                    },
                    submitFeedback: function(payload, success, error) {
                        Contrat.submitAssistantFeedback({id: vm.idContrat}, payload, success, error);
                    },
                    executeActions: function(payload, success, error) {
                        Contrat.executeAssistantActions({id: vm.idContrat}, payload, success, error);
                    },
                    refreshContextEntity: function() {
                        Contrat.get({id: vm.idContrat}, function(refreshedEntity) {
                            AssistantPanelService.updateContextEntity(refreshedEntity);
                            $rootScope.$emit('wamasysApp:contratUpdate', refreshedEntity);
                        });
                    }
                }
            });
        }

    }
})();
